import { gql } from "@apollo/client";

export default gql`
  query getPaymentBatch($id: Int!) {
    paymentBatch(id: $id) {
      ...PaymentBatchFields
    }
  }
`;
